export default __webpack_public_path__ + "static/media/WAS0400.34I-39819_-24592_0.a33f8d26.jpg";